import { render } from "./ModeSwitch.vue?vue&type=template&id=a0099b52"
import script from "./ModeSwitch.vue?vue&type=script&lang=js"
export * from "./ModeSwitch.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__